import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Limit } from '../../../../model/limit';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { LimitsService } from '../../../../resources/limits/limits.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import { Location } from '@angular/common';
import 'rxjs/add/operator/do';
import { MzToastService } from 'ng2-materialize';
import { isUndefined } from 'util';
import { FleetGroup } from '../../../../model/fleet-group';
import { FleetGroupsService } from '../../../../resources/fleet-groups/fleet-groups.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { lessOrEqualThen, moreThen } from '../../../../core/validators';

@Component({
  selector:    'app-limit',
  templateUrl: './limit.component.html',
  styleUrls:   [ './limit.component.scss' ],
  providers:   [ Location ]
})
export class LimitComponent implements OnInit {

  limit: Limit;

  limits: Limit[];

  fleetGroups: FleetGroup[];

  limitForm: FormGroup;

  id: number;

  loading: any;

  daily_error_messages = {
    min: 'Wartość musi być większa lub równa 0.',
    lessOrEqualThen: 'Wartość musi być mniejsza/równa wartości tygodniowej.'
  };

  weekly_error_messages = {
    min: 'Wartość musi być większa lub równa 0.',
    lessOrEqualThen: 'Wartość musi być mniejsza/równa wartości miesięcznej.',
    moreThen:        'Wartość musi być większa/równa wartości dziennej.'
  };


  monthly_error_messages = {
    min: 'Wartość musi być większa lub równa 0.',
    moreThen: 'Wartość musi być większa/równa wartości tygodniowej.'
  };

  constructor(private route: ActivatedRoute,
              private formBuilder: FormBuilder,
              private location: Location,
              private spinner: SpinnerService,
              private fleetGroupsService: FleetGroupsService,
              private toast: MzToastService,
              private limitsService: LimitsService) {

  }

  ngOnInit() {
    const fleet_groups$ = this.fleetGroupsService.query()
      .do((fleetGroups) => {
        this.fleetGroups = fleetGroups;
      });

    const params$ = this.route.params
      .do((params) => {
        this.id = +params.id;
      })
      .first();

    const limit$ = params$
      .switchMap(() => {
        if (isNaN(this.id)) {
          return Observable.of(new Limit());
        } else {
          return this.limitsService.get(this.id);
        }
      });


    fleet_groups$
      .switchMap(() => limit$)
      .catch(() => {
        this.toast.show('Nie można wczytać zasobów', 2000, 'error');
        this.location.back();
        return Observable.throw('cant_find_resource');
      })
      .subscribe((limit) => {
        this.limit = limit;
        this.buildForm();
      });
  }

  onSubmit() {
    const loading = this.spinner.show('Zapisuję...');

    let request;
    if (isUndefined(this.limit.id)) {
      request = this.limitsService.create(this.limitForm.value);
    } else {
      request = this.limitsService.update({ ...this.limit, ...this.limitForm.value } as Limit);
    }
    request.subscribe(() => {
        this.toast.show('Zapisano limit', 2000, 'success');
        this.location.back();
      },
      (error) => {
        loading.close();
        this.toast.show(`Nie można zapisać limitu. ${error}.`, 2000, 'error');
      });
  }

  back() {
    this.location.back();
  }

  private buildForm() {
    this.limitForm = this.formBuilder.group({
      name:                 [ this.limit.name,
                              Validators.required ],
      transactions_daily:   [ this.limit.transactions_daily,
                              Validators.min(0) ],
      amount_daily:         [ this.limit.amount_daily,
                              Validators.compose([
                                Validators.min(0),
                                lessOrEqualThen('amount_weekly')
                              ])
      ],
      amount_weekly:        [ this.limit.amount_weekly,
                              Validators.compose([
                                Validators.min(0),
                                lessOrEqualThen('amount_monthly'),
                                moreThen('amount_daily')
                              ])
      ],
      amount_monthly:       [ this.limit.amount_monthly,
                              Validators.compose([
                                Validators.min(0),
                                moreThen('amount_weekly')
                              ])
      ],
      quantitative_daily:   [ this.limit.quantitative_daily,
                              Validators.compose([
                                Validators.min(0),
                                lessOrEqualThen('quantitative_weekly')
                              ])
      ],
      quantitative_weekly:  [ this.limit.quantitative_weekly,
                              Validators.compose([
                                Validators.min(0),
                                lessOrEqualThen('quantitative_monthly'),
                                moreThen('quantitative_daily')
                              ])
      ],
      quantitative_monthly: [ this.limit.quantitative_monthly,
                              Validators.compose([
                                Validators.min(0),
                                moreThen('quantitative_weekly')
                              ]) ],

      no_fuel_daily:   [ this.limit.no_fuel_daily,
                         Validators.compose([
                           Validators.min(0),
                           lessOrEqualThen('no_fuel_weekly')
                         ])
      ],
      no_fuel_weekly:  [ this.limit.no_fuel_weekly,
                         Validators.compose([
                           Validators.min(0),
                           lessOrEqualThen('no_fuel_monthly'),
                           moreThen('no_fuel_daily')
                         ])
      ],
      no_fuel_monthly: [ this.limit.no_fuel_monthly,
                         Validators.compose([
                           Validators.min(0),
                           moreThen('no_fuel_weekly')
                         ])
      ],
      fleet_group_ids: [ this.limit.fleet_group_ids,
                         Validators.required ]
    });
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/forms/limit/limit.component.ts